// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  intelId: __t.u64().primaryKey().name("intel_id"),
  observer: __t.identity(),
  civ: __t.string(),
  systemId: __t.string().name("system_id"),
  sensor: __t.string(),
  observedAt: __t.timestamp().name("observed_at"),
  payload: __t.string(),
  updatedAt: __t.timestamp().name("updated_at"),
});
